import { render, staticRenderFns } from "./TwoStepVerificationPage.vue?vue&type=template&id=5e2395b5"
import script from "./TwoStepVerificationPage.vue?vue&type=script&lang=js"
export * from "./TwoStepVerificationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports